import { useLang } from "@/context/LangContext";

const TopReassuranceBar = () => {
  const { lang } = useLang();
  const items = lang === "fr"
    ? [
        "🚚 Livraison en Europe",
        "↩️ Retours 30 jours",
        "🔒 Paiement sécurisé SSL",
        "⭐ Satisfait ou remboursé",
      ]
    : [
        "🚚 Europe-wide shipping",
        "↩️ 30-day returns",
        "🔒 SSL secure payment",
        "⭐ Money-back guaranteed",
      ];

  return (
    <div
      data-testid="top-reassurance-bar"
      className="w-full bg-[#D4C4B0] text-[#3D2B1F] text-[12px] tracking-wide overflow-hidden"
    >
      {/* Desktop: static row */}
      <div className="hidden md:flex max-w-[1400px] mx-auto px-6 py-2 items-center justify-center gap-8">
        {items.map((s, i) => (
          <span key={i} className="whitespace-nowrap font-light">
            {s}
          </span>
        ))}
      </div>
      {/* Mobile: marquee scroll */}
      <div className="md:hidden">
        <div className="flex whitespace-nowrap flv-marquee py-2.5">
          {Array.from({ length: 2 }).map((_, blk) => (
            <div key={blk} className="flex shrink-0 items-center">
              {items.map((s, i) => (
                <span key={`${blk}-${i}`} className="px-6 font-light">
                  {s}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopReassuranceBar;
